import { useState } from 'react'

import { store } from 'redux/store'
import { useActionless } from 'redux/hooks'
import { SET_FOLDER_STATE } from 'redux/folders/actions/types'

import { SubfolderFolderItemType } from 'types/folders'

import FolderService from 'services/folder.service'
import ToastService from 'services/toast.service'

import PhatButton from 'components/formElements/PhatButton'
import Modal from 'components/elements/Modal'
import PhatInput from 'components/formElements/PhatInput'
import SimpleSpinner from 'components/elements/SimpleSpinner'

import styles from './folderRenameModal.module.scss'

type Props = {
  folder: SubfolderFolderItemType
  open: boolean
  onClose: () => void
}

const FolderRenameModal = ({ folder, open, onClose }: Props) => {
  const [name, setName] = useState(folder.name)
  const [loading, setLoading] = useState(false)

  const [setFolderState] = useActionless(SET_FOLDER_STATE)

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()

    setLoading(true)

    FolderService.updateItems([{ id: folder.id, type: 'folder', patch: { name } }])
      .then(() => FolderService.details())
      .then(data => {
        const { rootFolder } = store.getState().folders

        const updatedSubfolders = rootFolder.subfolders.map(subfolder => ({
          ...subfolder,
          name: subfolder.id === folder.id ? name : subfolder.name,
        }))

        setFolderState({ rootFolder: { ...rootFolder, subfolders: updatedSubfolders } })
        onClose()
      })
      .catch(ToastService.create)
      .finally(() => setLoading(false))
  }

  return (
    <Modal open={open} onClose={onClose} modalClassName={styles.container} closeButton>
      <h2>Rename folder: "{folder.name}"</h2>

      <form onSubmit={handleSubmit}>
        <PhatInput
          value={name}
          onChange={setName}
          header="Folder name"
          selectOnFocus
          placeholder="Shiny new folder name"
        />

        <div className={styles.controls}>
          <PhatButton color="green" type="submit" disabled={loading}>
            {!loading && <>Rename folder</>}

            {loading && (
              <>
                <SimpleSpinner size="xSmall" /> Renaming folder...
              </>
            )}
          </PhatButton>
        </div>
      </form>
    </Modal>
  )
}

export default FolderRenameModal
